import styled from 'styled-components';
import ReactLink from '@exo/frontend-common-link';
import theme from './Link.theme';

export const Link = styled(ReactLink)`
  align-items: center;
  color: inherit;
  display: flex;
  font: ${props => theme(props).font};

  &:hover,
  &:focus {
    outline: none;
    text-decoration: ${props => theme(props).hoverTextDecoration};
  }
`;